import React, {useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import {Button, Form} from "react-bootstrap";
import {BrowserView} from "react-device-detect";


const SearchForm = ({action, tripTypes, destinations, showBadge = false}) => {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const [search, setSearch] = useState(searchParams.get("s") ?? "");
    const [type, setType] = useState(searchParams.get("reiseart") ?? "");
    const [dest, setDest] = useState(searchParams.get("reiseziel") ?? "");

    const currentType = tripTypes?.find((t) => t.id === Number(type));
    const currentDest = destinations?.find((d) => d.ID === Number(dest));

    const reloadP = (search, type, dest) => {
        setSearch(search)
        setType(type)
        setDest(dest)
        navigate(`/reisefinder?s=${search}&tour_search=1&reiseart=${type}&reiseziel=${dest}`);
        window.location.reload();
    }

    return (
        <div className="position-sticky top-0">
            {showBadge &&
                <div className="row mb-3">
                    <div className="col-sm ">
                        {search &&
                            <span className="badge rounded-pill p-2">
                                                    {search}
                                <button className="button-icon"
                                        aria-label="Suchbegriff löschen"
                                        onClick={() => {
                                    reloadP("", type, dest)
                                }}><i
                                    className="fa fa-close ps-5"></i></button>
                                                </span>
                        }
                        {type &&
                            <span className="badge rounded-pill p-2">
                                                    {currentType?.title}
                                <button className="button-icon"
                                        aria-label="Reiseart filter löschen"
                                        onClick={() => {
                                    reloadP(search, "", dest)
                                }}><i
                                    className="fa fa-close ps-5"></i></button>
                                                </span>

                        }
                        {dest &&
                            <span className="badge rounded-pill p-2">
                                                    {currentDest?.Kontinent}
                                <button className="button-icon"
                                        aria-label="Reiseziel filter löschen"
                                        onClick={() => {
                                    reloadP(search, type, "")
                                }}><i
                                    className="fa fa-close ps-5"></i></button>
                                                </span>
                        }
                    </div>
                </div>
            }
            <div className="search_tour">
                <div className="form-block block-after-indent">
                    <h3 className="form-block_title">Reisefilter</h3>
                    <div className="form-block__description">Finden Sie Ihre Traumreise
                        jetzt!
                    </div>
                    <Form method="get" action={action}>
                        <input type="hidden" name="tour_search" value="1"/>
                        <Form.Group className="mb-3" controlId="formBasicSearch">
                            <Form.Control type="text" aria-label="Suchbegriff eingeben..."
                                          name="s"
                                          placeholder="Suchbegriff eingeben..."
                                          value={search}
                                          onChange={(e) => setSearch(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicTripDest">
                            <Form.Select aria-label="Reiseziel auswhälen"
                                         name="reiseziel"
                                         value={dest}
                                         onChange={(e) => setDest(e.target.value)}>
                                <option value=""> Alle Reiseziele</option>
                                {destinations?.map((post, x) => (
                                    <option value={post.ID}
                                            key={x}>{post.Kontinent_2012}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicTripType">
                            <Form.Select aria-label="Reiseart auswhälen"
                                         name="reiseart"
                                         value={type}
                                         onChange={(e) => setType(e.target.value)}>>
                                <option value="">Alle Reisearten</option>
                                {tripTypes?.map((post, i) => (
                                    <option value={post.id} key={i}>{post.title}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Suchen
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default SearchForm;